import React from 'react'
import { CheckCircle, XCircle } from 'lucide-react'

interface DebugStatusProps {
  debugStatus?: number
  debugMessage?: string
  statusCode?: number
}

export const DebugStatus: React.FC<DebugStatusProps> = ({
  debugStatus,
  debugMessage,
  statusCode
}) => {
  if (debugStatus === undefined && statusCode === undefined) {
    return null
  }

  // 优先使用debug_status，如果没有则使用statusCode
  const status = debugStatus !== undefined ? debugStatus : statusCode
  const message = debugMessage || 'No debug message'
  
  // 确定状态类型和样式
  const isSuccess = status === 0
  
  // 样式配置
  const getStatusConfig = () => {
    if (isSuccess) {
      return {
        bgColor: 'bg-green-50 dark:bg-green-900/20',
        borderColor: 'border-green-200 dark:border-green-800',
        textColor: 'text-green-800 dark:text-green-200',
        iconColor: 'text-green-600 dark:text-green-400',
        icon: CheckCircle
      }
    } else {
      return {
        bgColor: 'bg-red-50 dark:bg-red-900/20',
        borderColor: 'border-red-200 dark:border-red-800',
        textColor: 'text-red-800 dark:text-red-200',
        iconColor: 'text-red-600 dark:text-red-400',
        icon: XCircle
      }
    }
  }

  const config = getStatusConfig()
  const IconComponent = config.icon

  return (
    <div className={`rounded-lg border p-4 ${config.bgColor} ${config.borderColor}`}>
      <div className="flex items-start space-x-3">
        <IconComponent className={`h-5 w-5 mt-0.5 flex-shrink-0 ${config.iconColor}`} />
        <div className="flex-1 min-w-0">
          <div className="flex items-center space-x-2 flex-wrap">
            <h4 className={`text-sm font-medium ${config.textColor}`}>
              Debug Status
            </h4>
            <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${
              isSuccess 
                ? 'bg-green-100 dark:bg-green-900/30 text-green-800 dark:text-green-200' 
                : 'bg-red-100 dark:bg-red-900/30 text-red-800 dark:text-red-200'
            }`}>
              Code: {status}
            </span>
            {message && (
              <span className={`text-sm ${config.textColor} opacity-90`}>
                {message}
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}